import React from 'react';

function WordHistory({ wordPairs }) {
  return (
    <div className="word-history">
      <h2>Word History</h2>
      {wordPairs.map((entry, index) => (
        <div key={index} className="history-entry">
          <h3>{entry.date}</h3>
          <div className="word-list">
            {entry.words.map((word, wordIndex) => (
              <div key={wordIndex} className="word-pair">
                <span className="spanish">{word.spanish}</span>
                <span className="english">{word.english}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default WordHistory; 